angular.module('b2bLoginApp.services').factory('Company', ['$resource',
    function($resource){
        return $resource('company.json');
    }]);
